import React from 'react';
import { Plus, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { Product } from '../../data/mockProducts';
import { useCart } from '../../hooks/useCart';
interface RecipeBundleProps {
  title: string;
  description: string;
  products: Product[];
  totalPrice: number;
  savings: number;
}
export function RecipeBundle({
  title,
  description,
  products,
  totalPrice,
  savings
}: RecipeBundleProps) {
  const {
    addToCart
  } = useCart();
  const handleAddBundle = () => {
    products.forEach(product => addToCart(product));
  };
  return <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300" data-id="element-147">
      <div className="p-8 md:p-10 bg-gradient-to-br from-blue-50 to-white" data-id="element-148">
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-149">
          <div className="flex-1" data-id="element-150">
            <div className="inline-flex items-center gap-2 bg-purple-500/10 text-purple-600 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-151">
              <Sparkles className="w-3 h-3" data-id="element-152" />
              Bundle & Save
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-153">{title}</h3>
            <p className="text-gray-600 text-lg mb-6" data-id="element-154">{description}</p>

            <div className="flex items-center gap-4 mb-8" data-id="element-155">
              <div className="flex flex-col" data-id="element-156">
                <span className="text-sm text-gray-500 line-through" data-id="element-157">
                  ${(totalPrice + savings).toFixed(2)}
                </span>
                <span className="text-3xl font-bold text-blue-600" data-id="element-158">
                  ${totalPrice.toFixed(2)}
                </span>
              </div>
              <div className="bg-cyan-500/10 text-cyan-600 px-3 py-1 rounded-lg text-sm font-bold" data-id="element-159">
                Save ${savings.toFixed(2)}
              </div>
            </div>

            <button onClick={handleAddBundle} className="w-full md:w-auto flex items-center justify-center gap-2 bg-blue-600 text-white px-8 py-3.5 rounded-xl font-bold hover:bg-blue-700 transition-colors shadow-lg shadow-blue-600/20 active:scale-95" data-id="element-160">
              <Plus className="w-5 h-5" data-id="element-161" />
              Add Bundle to Cart
            </button>
          </div>

          <div className="flex-1 w-full max-w-md" data-id="element-162">
            <div className="grid grid-cols-2 gap-3" data-id="element-163">
              {products.map((product, index) => <motion.div key={`${product.id}-${index}`} className="aspect-square rounded-xl overflow-hidden border border-white shadow-sm" initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: index * 0.1
            }} viewport={{
              once: true
            }} data-id="element-164">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" data-id="element-165" />
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}